export default "__VITE_ASSET__xOLrLI5Y__"